import { Injectable } from '@angular/core';

import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import * as moment from 'moment';

import {saveAs as importedSaveAs} from "file-saver";

import { environment } from './../../environments/environment';
import { Contributor } from '../models/Contributor';

import { SharedService } from './shared.service';

@Injectable()
export class ContributorService {
  selectedId: string;
  selectedCodice: string;

  get selected(): string {
    return this.selectedCodice;
  }
  set selected(codice: string) {
    this.selectedCodice = codice;
  }

  constructor(public sharedService: SharedService, private http: Http) { }

  getContributorPhotoPath(codice: string) {
    return environment.server.url + '/static/media/contributors/' + environment.publisher + '/' + codice + '.jpg' + '?random=' + Math.random();
  }
  
  search(opt:any): Observable<any> {
    return this.http.post(environment.server.url + '/contributor/search', opt)
      .map(response => response.json())
  }

  getContributor(codice: string) {
    console.log('codice', codice)
    return this.http.post(environment.server.url + '/contributor/find-one', { codice: codice })
      .map(response => response.json())
  }

  persist(wmodel: any) {
    console.log('persist', wmodel)
    return this.http.post(environment.server.url + '/contributor/persist', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('persist', r)
        if (r.success) {
          console.log('persist - emit', r.result.value)
          this.sharedService.sharedEmitter.emit(r.result.value)
        }
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  remove(wmodel: Contributor) {
    console.log('remove contributor', wmodel)
    return this.http.post(environment.server.url + '/contributor/remove', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('remove contributor', r)
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  downloadFile(wq) {
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(environment.server.url + '/contributor/download', { filter: wq, download: true }, options)
      .map(response => {
        let fileBlob = response.blob();
        let blob = new Blob([fileBlob], {
          type: 'application/vnd.ms-excel'
        })
        return blob;
      })
      .catch(this.handleError)
  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/contributor.service.ts